import React, { Component } from "react";
import "antd/dist/antd.css";
import { Row, Col, Form, Card, Table, Tag, Spin, message, Upload } from "antd";
import companylogo from "../../Images/companylogo.png";
import Iconedit from "../../Images/Iconedit.png";
import Iconlocation from "../../Images/Iconlocation.png";
import email from "../../Images/Iconmail.png";
// import { Link } from 'react-router-dom';
import Amplify, { Storage } from "aws-amplify";
import awsConfigure from "../../Config/AwsConfig";
import AppConfigs from "../../Config/AppConfig";
import { getDetails, list, update } from "../../api/Apis";
import moment from "moment";
import { formatPhoneNumber } from "../commonFunctions";
import RequestLead from "../../Components/RequestLead";
import LoadDelivered from "../../Components/LoadDelivered";
import GeneratePdf from "../../Components/GeneratePdf";
import { PhoneFilled } from "@ant-design/icons";

Amplify.configure(awsConfigure);

class Review extends Component {
  state = {
    orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
    loading: false,
    visible: false,
    companylogo: companylogo,
    companyData: {},
    leadData: {},
    customerData: {},
    driversList: [],
    dataSource: [],
    selectedDriver: "",
    dataLoadingStatus: true,
    rateValue: "",
    callForRate: false,
    pickDateAndTimeModal: false,
    uploadCompanyLogoLoading: false,
    loader2: false,
    delImage: "",
    delTicket: "",
    isLoadRequested: false,
  };

  componentDidMount() {
    this.getLoadDetails();
  }

  getLoadDetails = () => {
    this.setState({
      dataLoadingStatus: true,
    });
    getDetails(
      AppConfigs["entityNames"]["leads"],
      this.props.match.params.id
    ).then(async (result) => {
      if (result.success) {
        let pickDateAndTimeModal = false;
        // let deliveryImage = []
        let deliveryImage = "",
          deliverylTicket = "";
        if (!result.data["pickupDate"] && result.data["orderStatus"] === "AC") {
          pickDateAndTimeModal = true;
        }
        this.setState({
          leadData: result.data,
          rateValue: result.data["rateValue"] ? result.data["rateValue"] : "0",
          callForRate: result.data["callForRate"]
            ? result.data["callForRate"]
            : false,
        });
        if (this.state.leadData["leadDeliveryImage"]) {
          deliveryImage = await Storage.get(
            this.state.leadData["leadDeliveryImage"]["delivery_pic"]
              ? this.state.leadData["leadDeliveryImage"]["delivery_pic"]
              : this.state.leadData["leadDeliveryImage"]
          );
          deliverylTicket = await Storage.get(
            this.state.leadData["leadDeliveryImage"]["delivery_ticket_pic"]
              ? this.state.leadData["leadDeliveryImage"]["delivery_ticket_pic"]
              : this.state.leadData["leadDeliveryImage"]
          );
        }
        if (
          this.state.leadData["carrierRequests"] &&
          this.state.leadData["carrierRequests"].length > 0
        ) {
          // eslint-disable-next-line array-callback-return
          this.state.leadData["carrierRequests"].map((r) => {
            if (r.carrierEmail === this.state.orgDetails.email) {
              this.setState({ isLoadRequested: true });
            }
          });
        }

        this.setState({
          delImage: deliveryImage,
          delTicket: deliverylTicket,
          uploadCompanyLogoLoading: false,
        });

        getDetails(
          AppConfigs["entityNames"]["registrations"],
          result.data["customerId"]
        ).then(async (customerRes) => {
          if (customerRes.success) {
            this.setState({
              customerData: customerRes.data,
            });
            getDetails(
              AppConfigs["entityNames"]["organizations"],
              customerRes.data["orgId"]
            ).then(async (orgRes) => {
              if (orgRes.success) {
                let complogo = this.state.companylogo;
                if (orgRes["data"]["companyLogo"]) {
                  complogo = await Storage.get(orgRes["data"]["companyLogo"]);
                }
                this.setState({
                  pickDateAndTimeModal: pickDateAndTimeModal,
                  dataLoadingStatus: false,
                  companylogo: complogo,
                  companyData: orgRes.data,
                });
                let query = {
                  userProfile: "D",
                };
                list(AppConfigs["entityNames"]["users"], query).then(
                  (driversRes) => {
                    if (driversRes.success) {
                      this.setState({
                        driversList: driversRes.data,
                      });
                    } else {
                      console.log(driversRes.errors);
                    }
                  }
                );
              } else {
                console.log(orgRes.errors);
                this.setState({
                  dataLoadingStatus: false,
                });
              }
            });
          } else {
            console.log(customerRes.errors);
            this.setState({
              dataLoadingStatus: false,
            });
          }
        });
      } else {
        console.log(result.errors);
        this.setState({
          dataLoadingStatus: false,
        });
      }
    });
  };

  handleCompanyLogoChange = async (fileData) => {
    // e.preventDefault();
    this.setState({
      uploadCompanyLogoLoading: true,
    });
    let file = fileData["file"]["originFileObj"];
    let leadData = this.state.leadData;
    // let fileName = leadData["id"] + "_lead_delivery_pic_" + file["name"];
    let fileName =
      leadData["subOrderId"] + "_lead_delivery_pic_" + file["name"];
    await Storage.put(fileName, file, {
      contentType: file.type,
    }).then((result) => {
      let data = {};
      data["entityData"] = {};
      data["entityData"]["leadDeliveryImage"] = result.key;
      update(
        AppConfigs["entityNames"]["leads"],
        this.state.leadData["id"],
        data
      ).then(async (result) => {
        if (result.success) {
          leadData["leadDeliveryImage"] =
            data["entityData"]["leadDeliveryImage"];
          this.getLoadDetails();
        } else {
          this.setState({
            uploadCompanyLogoLoading: false,
          });
          console.log(result.errors);
        }
      });
    });
  };

  editPickupDateAndTime = () => {
    this.setState({ pickDateAndTimeModal: true });
  };

  checkLeadOrderStatus = () => {
    // this.setState({ pickDateAndTimeModal: true })
    this.setState({
      dataLoadingStatus: true,
    });
    getDetails(
      AppConfigs["entityNames"]["leads"],
      this.props.match.params.id
    ).then(async (result) => {
      if (result.success) {
        if (result.data["orderStatus"] === AppConfigs["PUSH_TO_CARRIER"]) {
          this.setState({
            dataLoadingStatus: false,
            pickDateAndTimeModal: true,
          });
        } else {
          message.error("This load already assigned");
          this.props.history.push("/carrier_app/allOrders");
        }
      }
    });
  };

  fileDownload = async (fileName, loader) => {
    if (loader === "I2") {
      this.setState({
        loader2: true,
      });
    } else {
      this.setState({
        uploadCompanyLogoLoading: true,
      });
    }
    Storage.get(fileName, { download: true }).then((res) =>
      this.downloadBlob(res.Body, fileName, loader)
    );
  };

  downloadBlob(blob, filename, loader) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    if (loader === "I2") {
      this.setState({
        loader2: false,
      });
    } else {
      this.setState({
        uploadCompanyLogoLoading: false,
      });
    }
    return a;
  }
  render() {
    const props = {
      onChange: this.handleCompanyLogoChange,
      multiple: false,
    };
    const columns = [
      {
        title: <div style={{ color: "gray" }}>Product Name</div>,
        dataIndex: "productName",
        key: "productName",
        render: (productName) => (
          <div style={{ color: "black" }}>{productName}</div>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Product Size</div>,
        dataIndex: "size",
        key: "size",
        render: (size) => <div style={{ color: "black" }}>{size}</div>,
      },
      {
        title: <div style={{ color: "gray" }}>Measurement</div>,
        dataIndex: "measurementType",
        key: "measurementType",
        render: (measurementType, record) => (
          <span>
            <div style={{ color: "black" }}>
              {measurementType.toLowerCase()}
            </div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Quantity</div>,
        dataIndex: "quantity",
        key: "quantity",
        render: (quantity) => (
          <span>
            <div style={{ color: "black" }}>{quantity}</div>
          </span>
        ),
      },
      {
        title: <div style={{ color: "gray" }}>Type of Truck</div>,
        dataIndex: "deliveryTruck",
        key: "deliveryTruck",
        render: (deliveryTruck) => (
          <span>
            <div style={{ color: "black" }}>{deliveryTruck}</div>
          </span>
        ),
      },
    ];

    return (
      <div style={{ padding: "30px" }}>
        <Spin spinning={this.state.dataLoadingStatus}>
          <Row style={{}}>
            {!this.state.dataLoadingStatus && (
              <RequestLead
                leadData={this.state.leadData}
                modalStatus={this.state.pickDateAndTimeModal}
                callFrom="details"
                getLoadDetails={() => this.getLoadDetails()}
                hideModal={() => {
                  this.setState({ pickDateAndTimeModal: false });
                }}
              />
            )}
            <Col span={12}>
              <h3 className="ordertext">
                {"Order: #" +
                  (this.state.leadData["orderId"]
                    ? this.state.leadData["orderId"]
                    : "")}
              </h3>
            </Col>
            <Col span={12} className="available-loads-column">
              {this.state.leadData["orderStatus"] ===
                AppConfigs["DELIVERED"] && (
                <div style={{ display: "inline-flex", float: "right" }}>
                  <GeneratePdf
                    leadData={this.state.leadData}
                    callFrom="carriers"
                    pathName="orderDetails"
                    startLoading={() =>
                      this.setState({ dataLoadingStatus: true })
                    }
                    stopLoading={() =>
                      this.setState({ dataLoadingStatus: false })
                    }
                  />
                </div>
              )}
              {this.state.leadData["orderStatus"] ===
                AppConfigs["ASSIGN_TO_CARRIER"] && (
                <div style={{ display: "inline-flex", float: "right" }}>
                  <GeneratePdf
                    leadData={this.state.leadData}
                    callFrom="carriers"
                    pathName="orderDetails"
                    startLoading={() =>
                      this.setState({ dataLoadingStatus: true })
                    }
                    stopLoading={() =>
                      this.setState({ dataLoadingStatus: false })
                    }
                  />
                </div>
              )}
              {this.state.leadData["orderStatus"] ===
                AppConfigs["IN_PROGRESS"] &&
                this.state.leadData["carrierId"] ===
                  this.state.orgDetails["id"] && (
                  <div style={{ display: "inline-flex", float: "right" }}>
                    <LoadDelivered
                      leadData={this.state.leadData}
                      callFrom="details"
                      getOrders={() => this.getLoadDetails()}
                    />
                    <GeneratePdf
                      leadData={this.state.leadData}
                      callFrom="carriers"
                      pathName="orderDetails"
                      startLoading={() =>
                        this.setState({ dataLoadingStatus: true })
                      }
                      stopLoading={() =>
                        this.setState({ dataLoadingStatus: false })
                      }
                    />
                  </div>
                )}
              {this.state.leadData["orderStatus"] ===
                AppConfigs["PUSH_TO_CARRIER"] && (
                <>
                  <div style={{ display: "inline-flex", float: "right" }}>
                    <span className="rate">
                      {this.state.leadData["callForRate"]
                        ? "Call for Rate"
                        : this.state.leadData["rateValue"]
                        ? "Rate: $" +
                          this.state.leadData["rateValue"] +
                          "/" +
                          this.state.leadData["rateOption"]
                        : "Rate: $0"}
                    </span>
                    {/* <Link to="#" className="pdf">Download PDF</Link> */}
                    {!this.state.isLoadRequested && (
                      <span
                        className="assign"
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          this.checkLeadOrderStatus();
                        }}
                      >
                        Request this Load
                      </span>
                    )}
                    <GeneratePdf
                      leadData={this.state.leadData}
                      callFrom="carriers"
                      pathName="orderDetails"
                      startLoading={() =>
                        this.setState({ dataLoadingStatus: true })
                      }
                      stopLoading={() =>
                        this.setState({ dataLoadingStatus: false })
                      }
                    />
                  </div>
                </>
              )}
            </Col>
          </Row>
          <Row gutter={20}>
            <Col lg={7} md={7} sm={24} xs={24}>
              <div className="site-card-border-less-wrapper">
                <Card style={{ borderRadius: "10px" }}>
                  <Row className="detailsborder">
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h4 className="Companyheadinglabel">Company Details</h4>
                    </Col>
                    {/* <Col lg={12} md={12} sm={24} xs={24} style={{ textAlign: 'right' }}>
                    <Link className="switchcompany">Switch Company</Link>
                  </Col> */}
                  </Row>
                  <Row className="companyrow">
                    <Col
                      lg={10}
                      md={10}
                      sm={24}
                      xs={24}
                      style={{ textAlign: "center" }}
                    >
                      <img
                        src={this.state.companylogo}
                        style={{
                          marginRight: "10px",
                          width: "85px",
                          marginBottom: "10%",
                        }}
                        alt="logo"
                      />
                    </Col>
                    <Col
                      lg={14}
                      md={14}
                      sm={24}
                      xs={24}
                      style={{ marginTop: "auto", marginBottom: "auto" }}
                    >
                      <h5 className="companynamelabel">COMPANY NAME</h5>
                      <h2 className="companyname">
                        {this.state.companyData["orgName"] &&
                          this.state.companyData["orgName"]}
                      </h2>
                    </Col>
                  </Row>
                  <h5 className="contactinfo" style={{ marginTop: "10px" }}>
                    CONTACT INFO
                  </h5>
                  {/* <div>
                    <img src={Iconuser} className="icons" alt="User icon" /><span className="contactdetails">{this.state.companyData["orgName"] && this.state.companyData["orgName"]}</span>
                  </div>
                  <div>
                    <img src={Iconmail} className="icons" alt="Email" /><span className="contactdetails">{this.state.companyData["orgName"] && this.state.companyData["orgName"]}</span>
                  </div>
                  <div>
                    <img src={Iconphone} className="icons" alt="Phone" /><span className="contactdetails">{this.state.companyData["orgName"] && this.state.companyData["orgName"]}</span>
                  </div> */}
                  <div>
                    <img src={Iconlocation} className="icons" alt="Location" />
                    <span className="contactdetails">
                      {this.state.companyData["address"] &&
                        this.state.companyData["address"]}
                    </span>
                    <h3>
                      <PhoneFilled
                        style={{
                          color: "#7b8090",
                          fontSize: "1.3em",
                          marginLeft: "10px",
                          marginRight: "35px",
                        }}
                      />
                      <span className="contactdetails">
                        {this.state.companyData["phone"] &&
                          formatPhoneNumber(this.state.companyData["phone"])}
                      </span>
                    </h3>
                    {/* <h3><PhoneFilled style={{ color: '#7b8090', fontSize: '1.3em', marginLeft: '10px', marginRight: '35px' }} /><span className="contactdetails">{formatPhoneNumber(this.state.companyData["phone"])}</span></h3> */}
                    <img src={email} className="icons" alt="Email" />
                    <span className="contactdetails">
                      {/* {this.state.companyData["email"] && this.state.companyData["email"]} */}
                      office@defeomaterials.com
                    </span>
                  </div>

                  {/* <h5 className="notes" >PHONE</h5>
                  <h5 className="loaddetailtext">{this.state.companyData["phone"] && formatPhoneNumber(this.state.companyData["phone"])}</h5> */}
                </Card>
              </div>
            </Col>
            <Col lg={8} md={10} sm={24} xs={24}>
              <div className="site-card-border-less-wrapper">
                <Card style={{ borderRadius: "10px" }}>
                  <Row className="detailsborder">
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h4 className="Companyheadinglabel">Load Details</h4>
                    </Col>
                    <Col
                      lg={12}
                      md={12}
                      sm={24}
                      xs={24}
                      style={{ textAlign: "right" }}
                    >
                      {/* <Link  ><img src={Iconedit} alt="Edit" /></Link> */}
                      {(this.state.leadData["orderStatus"] ===
                        AppConfigs["ASSIGN_TO_CARRIER"] ||
                        this.state.leadData["orderStatus"] ===
                          AppConfigs["IN_PROGRESS"]) && (
                        <span
                          onClick={() => {
                            this.editPickupDateAndTime();
                          }}
                          style={{ cursor: "pointer" }}
                        >
                          <img
                            src={Iconedit}
                            alt={"Edit"}
                            style={{ width: "15px", float: "right" }}
                          />
                        </span>
                      )}
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Distance</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      <h5 className="loaddetailtext">
                        {isNaN(this.state.leadData["distanceMiles"]) ||
                        this.state.leadData["distanceMiles"] === null
                          ? ""
                          : this.state.leadData["distanceMiles"]}
                        <span style={{ color: "#7B8190", marginLeft: "20px" }}>
                          {isNaN(this.state.leadData["distanceMiles"]) ||
                          this.state.leadData["distanceMiles"] === null
                            ? ""
                            : "miles"}
                        </span>
                      </h5>
                    </Col>
                  </Row>
                  {/* <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Date and Time Ordered</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24} >
                      <h5 className="loaddetailtext">{this.state.leadData["createdAt"] && moment(this.state.leadData["createdAt"]).format("MM/DD/YYYY")}<span style={{ color: '#7B8190', marginLeft: '20px' }}>{this.state.leadData["createdAt"] && moment(this.state.leadData["createdAt"]).format("hh:mm A")}</span></h5>
                    </Col>
                  </Row> */}
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">
                        Requested Delivery Date
                      </h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      <h5 className="loaddetailtext">
                        {this.state.leadData["deliveryReqDate"] &&
                          moment(this.state.leadData["deliveryReqDate"]).format(
                            "MM/DD/YYYY"
                          )}
                        <span style={{ color: "#7B8190", marginLeft: "20px" }}>
                          {this.state.leadData["deliveryReqTime"] &&
                            this.state.leadData["deliveryReqTime"]}
                        </span>
                      </h5>
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Load Pickup Date</h5>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      {this.state.leadData["pickupDate"] && (
                        <h5 className="loaddetailtext">
                          {this.state.leadData["pickupDate"]}
                          <span
                            style={{ color: "#7B8190", marginLeft: "20px" }}
                          >
                            {this.state.leadData["pickupStartTime"] +
                              " - " +
                              this.state.leadData["pickupEndTime"]}
                          </span>
                        </h5>
                      )}
                    </Col>
                    {/* <Col lg={3} md={3} sm={24} xs={24}>
                      <span onClick={() => { this.editPickupDateAndTime() }} style={{ cursor: "pointer" }}><img src={Iconedit} alt={"Edit"} style={{ width: "15px", float: 'right' }} /></span>
                    </Col> */}
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Load Origin</h5>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h3>
                        {this.state.leadData["address"] &&
                          this.state.leadData["productOriginDetails"][
                            "locationName"
                          ]}
                      </h3>
                      <h3>
                        {this.state.leadData["address"] &&
                          this.state.leadData["productOriginDetails"][
                            "address"
                          ]}
                      </h3>
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Delivery Date</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      <h5 className="loaddetailtext">
                        {this.state.leadData["deliveryDateAndTime"]}
                      </h5>
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Truck Assigned</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      {/* <h5 className="loaddetailtext">{this.state.leadData["driverDetails"] && this.state.leadData["driverDetails"]["truckNumber"]}</h5> */}
                      <h5 className="loaddetailtext">
                        {this.state.leadData["truckDetails"] &&
                          this.state.leadData["truckDetails"]["typeOfTruck"] &&
                          this.state.leadData["truckDetails"]["typeOfTruck"] +
                            " -" +
                            this.state.leadData["truckDetails"]["truckNumber"]}
                      </h5>
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Driver Assigned</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      <h5 className="loaddetailtext">
                        {this.state.leadData["driverDetails"] &&
                          this.state.leadData["driverDetails"]["name"]}
                      </h5>
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Notes</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      <h5 className="loaddetailtext">
                        {this.state.leadData["notes"] &&
                          this.state.leadData["notes"]}
                      </h5>
                    </Col>
                  </Row>
                </Card>
              </div>
            </Col>
            <Col lg={9} md={7} sm={24} xs={24}>
              <div className="site-card-border-less-wrapper">
                <Card style={{ borderRadius: "10px" }}>
                  <Row className="detailsborder">
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h4 className="Companyheadinglabel">Customer Details</h4>
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Company</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      <h5 className="loaddetailtext">
                        {this.state.customerData["companyName"] &&
                          this.state.customerData["companyName"]}
                      </h5>
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Customer Name</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      <h5 className="loaddetailtext">
                        {this.state.leadData["customerName"] &&
                          this.state.leadData["customerName"]}
                      </h5>
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Phone</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      <h5 className="loaddetailtext">
                        {this.state.customerData["phone"] &&
                          formatPhoneNumber(this.state.customerData["phone"])}
                      </h5>
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Email</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      <h5 className="loaddetailtext">
                        {this.state.customerData["email"] &&
                          this.state.customerData["email"]}
                      </h5>
                    </Col>
                  </Row>
                  <Row className="loaddetailsrow">
                    <Col lg={9} md={9} sm={24} xs={24}>
                      <h5 className="loaddetailheading">Location</h5>
                    </Col>
                    <Col lg={15} md={15} sm={24} xs={24}>
                      <h5 className="loaddetailtext">
                        {this.state.leadData["address"] &&
                          this.state.leadData["address"]}
                      </h5>
                    </Col>
                  </Row>
                </Card>
              </div>
            </Col>
            <Col lg={17} md={17} sm={24} xs={24} style={{ marginTop: "2%" }}>
              <div className="site-card-border-less-wrapper">
                <Card style={{ borderRadius: "10px" }}>
                  <div>
                    <Row className="detailsborder">
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <h4 className="Companyheadinglabel">Product Details</h4>
                      </Col>
                    </Row>
                    <Table
                      columns={columns}
                      dataSource={
                        this.state.leadData["cartItems"]
                          ? this.state.leadData["cartItems"]
                          : this.state.leadData["items"]
                          ? this.state.leadData["items"]
                          : []
                      }
                      pagination={false}
                      loading={this.state.dataLoadingStatus}
                      style={{ marginTop: "2%", overflowX: "auto" }}
                      rowKey={(record) => record.id}
                    />
                    <div style={{ marginTop: "2%" }}>
                      <Col lg={12} md={12} sm={24} xs={24}>
                        <p
                          style={{
                            color: "black",
                            fontSize: "15px",
                            float: "left",
                          }}
                        >
                          Status:&nbsp;
                          <span className="status_tag">
                            <Tag
                              color={
                                AppConfigs["STATUS_COLORS"][
                                  this.state.leadData["orderStatus"]
                                ]
                              }
                              style={{
                                color: "black",
                                height: "27px",
                                fontSize: "12px",
                                fontWeight: "bold",
                              }}
                            >
                              {
                                AppConfigs["DISPLAY_LEAD_STATUS"]["carrier"][
                                  this.state.leadData["orderStatus"]
                                ]
                              }
                            </Tag>
                          </span>
                        </p>
                      </Col>
                    </div>
                  </div>
                </Card>
              </div>
            </Col>
            <Col lg={7} md={7} sm={24} xs={24} style={{ marginTop: "2%" }}>
              {this.state.leadData["orderStatus"] ===
                AppConfigs["DELIVERED"] && (
                <div>
                  {/* {this.state.leadData["leadDeliveryImage"] ? */}
                  <div className="site-card-border-less-wrapper">
                    <Card style={{ borderRadius: "10px" }}>
                      <div>
                        <Row className="detailsborder">
                          <Col lg={12} md={12} sm={24} xs={24}>
                            <h4 className="Companyheadinglabel">
                              Load Delivered Image
                            </h4>
                          </Col>
                        </Row>
                        <Row>
                          <Col
                            lg={10}
                            md={10}
                            sm={24}
                            xs={24}
                            style={{ textAlign: "center", marginTop: "6%" }}
                          >
                            {this.state.leadData["leadDeliveryImage"] ? (
                              <Spin
                                spinning={this.state.uploadCompanyLogoLoading}
                              >
                                <img
                                  src={this.state.delImage}
                                  style={{ width: "100px", height: "100px" }}
                                  alt="logo"
                                />
                                <p
                                  style={{
                                    marginTop: "5%",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                  onClick={() => {
                                    this.fileDownload(
                                      this.state.leadData["leadDeliveryImage"][
                                        "delivery_pic"
                                      ]
                                        ? this.state.leadData[
                                            "leadDeliveryImage"
                                          ]["delivery_pic"]
                                        : this.state.leadData[
                                            "leadDeliveryImage"
                                          ]
                                    );
                                  }}
                                >
                                  Download Image
                                </p>
                              </Spin>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col
                            lg={14}
                            md={14}
                            sm={24}
                            xs={24}
                            style={{ marginTop: "auto", marginBottom: "auto" }}
                          >
                            {this.state.leadData["leadDeliveryImage"] ? (
                              <Spin spinning={this.state.loader2}>
                                <img
                                  src={this.state.delTicket}
                                  style={{ width: "100px", height: "100px" }}
                                  alt="logo"
                                />
                                <p
                                  style={{
                                    marginTop: "5%",
                                    cursor: "pointer",
                                    textDecoration: "underline",
                                  }}
                                  onClick={() => {
                                    this.fileDownload(
                                      this.state.leadData["leadDeliveryImage"][
                                        "delivery_ticket_pic"
                                      ]
                                        ? this.state.leadData[
                                            "leadDeliveryImage"
                                          ]["delivery_ticket_pic"]
                                        : this.state.leadData[
                                            "leadDeliveryImage"
                                          ],
                                      "I2"
                                    );
                                  }}
                                >
                                  Download Image
                                </p>
                              </Spin>
                            ) : (
                              ""
                            )}
                          </Col>

                          {/* <Col lg={14} md={14} sm={24} xs={24} style={{ marginTop: 'auto', marginBottom: 'auto' }}>
                            <Upload {...props} fileList={this.state.fileList}>
                              <h2
                                style={{
                                  color: "#1A5EB9",
                                  marginTop: "60px",
                                  cursor: "pointer",
                                  textDecoration: "underline",
                                }}
                              >
                                Upload Image
                              </h2>
                            </Upload>
                          </Col> */}
                        </Row>
                      </div>
                    </Card>
                  </div>
                  {/* :
                ""
              } */}
                </div>
              )}
            </Col>
          </Row>
        </Spin>
      </div>
    );
  }
}

export default Form.create({ name: "Review" })(Review);
// export default Review;
